import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

/**
 * Componente para paginação de componentes em array
 * @prop items array com a informação a ser paginada
 * @prop renderItem função para renderização de cada componente. Deve devolver um componente React
 */
export default class Paginate extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			page: 1,
			itemsPerPage: props.itemsPerPage || 8
		};
		this.refTop = React.createRef()
	}

	setPage = (pagination) => {
		const page = pagination.selected + 1;

		if (!this.props.url || this.state.data?.hasOwnProperty(page)) {
			// fazer scroll apenas se elemento top escondido
			const bounds = this.refTop.current instanceof React.Component ? null : this.refTop.current.getBoundingClientRect();
			if (bounds && bounds.top < 0) {
				window.scrollTo(0, this.refTop.current.offsetTop);
			}
			if (this.props.pageChanging && !this.props.items[(page - 1) * this.state.itemsPerPage]) {
				this.props.pageChanging(page).then(() => {
					this.setState({page: page})
				});
			}
			else {
				this.setState({page: page});
			}
		}
		else {
			this.fetch(page)
		}
	}

	fetch(page, url = null) {
		url = url || this.props.url;

		http.get(
			url || url, {
				item_per_page: this.state.itemsPerPage,
				page: page
			},
			response => {
				if (!this.state.data || url != this.props.url) {
					this.state.data = {};
				}
				this.state.data[page] = response.data;
				this.setState({
					url: url,
					page: response.meta.page,
					itemCount: response.meta.item_count
				});
			}
		);
	}

	componentDidMount() {
		if (this.props.url) {
			this.fetch(1)
		}
	}

	componentWillReceiveProps(props) {
		if (props.url && props.url != this.state.url) {
			this.fetch(1, props.url);
		}
	}

	render() {
		//const items = (this.state.data ? this.state.data[this.state.page] : this.props.items) || [];
		let items, start, end;

		if (this.state.data) {
			items = this.state.data[this.state.page] || [];
			start = 0;
			end = items.length;
		}
		else {
			items = this.props.items || [];
			start = (this.state.page - 1) * this.state.itemsPerPage;
			end = Math.min(start + this.state.itemsPerPage, items.length);
		}
		if (items.length == 0) {
			return null;
		}
		const pages = Math.ceil( (this.state.itemCount || this.props.itemCount || items.length) / this.state.itemsPerPage );
		if (this.state.page > pages) {
			this.state.page = pages;
		}
		//let start = (this.state.page - 1) * this.state.itemsPerPage;
		//let end = Math.min(start + this.state.itemsPerPage, items.length);
		let items_page = [];

		if (this.props.renderItem instanceof Function) {
			const el = this.props.el || 'div';

			for (let i = 0; start < end; start ++, i ++) {
				const props = {key: start, className: classNames("page_" + start, this.props.classNameEl)};

				if (i == 0) {
					props.ref = this.refTop;
				}
				items_page.push(
					this.props.el === null
						? this.props.renderItem(items[start], i, props)
						: React.createElement(el, props, this.props.renderItem(items[start], i))
				);
			}
		}
		else if (this.props.children) {
			for (let i = 0; start < end; start ++, i ++) {
				const props = {item: items[start], index: i};

				if (i == 0) {
					props.ref = this.refTop;
				}
				items_page.push(
					React.Children.map(this.props.children, child =>
						<child.type {...child.props} {...props} />
						//React.cloneElement(child, props)
					)
				)
			}
		}
		if (pages > 1) {
			const page_nav =
				<ReactPaginate
					key='pag'
					initialPage={this.props.forcePage ? undefined : this.state.page - 1}
					forcePage={this.props.forcePage || undefined}
					previousLabel={this.props.previousLabel || <em className="la la-angle-left" />}
					nextLabel={this.props.nextLabel || <em className="la la-angle-right" />}
					pageCount={pages}
					containerClassName='pagination'
					subContainerClassName='pages page-item'
					activeClassName='active'
					onPageChange={this.props.onPageChange || this.setPage}
				/>;
			items_page.push(this.props.paginationContainer ? this.props.paginationContainer(page_nav) : page_nav);
		}
		return items_page;
	}
}

Paginate.propTypes = {
	items: PropTypes.array
}